import { render, staticRenderFns } from "./AppInstallPrompt.vue?vue&type=template&id=716cd0d8&scoped=true&"
import script from "./AppInstallPrompt.vue?vue&type=script&lang=js&"
export * from "./AppInstallPrompt.vue?vue&type=script&lang=js&"
import style0 from "./AppInstallPrompt.vue?vue&type=style&index=0&id=716cd0d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716cd0d8",
  null
  
)

export default component.exports